/**
 * Source unique de vérité pour « ce compte utilisateur est-il encore actif ? ».
 *
 * Modèle : un compte fermé porte `isDeleted: true` dans `users/{uid}`, avec un
 * `deletionType` qui distingue la désactivation (le compte existe toujours dans
 * Firebase Auth, mais est `disabled`) de l'archivage (le compte a été retiré de
 * Auth). Cf. `functions/passwordManagement/passwordManagement.js`.
 *
 * Règle d'usage — la distinction est structurante, ne pas l'aplatir :
 *
 * - **Listes de sélection** (pickers, options de Select, listes d'équipe,
 *   compteurs) → filtrer avec `filterActiveUsers`. On ne propose jamais
 *   d'assigner une tâche, un rôle ou une campagne à un compte fermé.
 * - **Résolutions d'identité** (retrouver le nom de l'auteur d'une observation,
 *   d'une note, d'un edit dans un historique) → NE PAS filtrer. Un compte fermé
 *   reste l'auteur légitime de ce qu'il a produit ; le filtrer ferait afficher
 *   « utilisateur inconnu » rétroactivement.
 */

/**
 * @param {Object} user - document `users/{uid}` (ou objet dérivé qui a conservé
 *   le champ `isDeleted`).
 * @returns {boolean} true si le compte n'est ni désactivé ni archivé.
 */
export const isActiveUser = (user) => !!user && user.isDeleted !== true;

/**
 * @param {Array} userList
 * @returns {Array} la liste privée de ses comptes fermés (tableau vide si
 *   l'entrée est nulle, pour rester utilisable directement en `options={}`).
 */
export const filterActiveUsers = (userList) =>
  (userList || []).filter(isActiveUser);
